/** @jsx builderX.jsx */

import { builderX, Sprite, Image, MovieClip } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='bigWinParticlesNonAsian'>
        <MovieClip name='emerald'>
            <Image src='emerald00000' />
            <Image src='emerald00001' />
            <Image src='emerald00002' />
            <Image src='emerald00003' />
            <Image src='emerald00004' />
            <Image src='emerald00005' />
            <Image src='emerald00006' />
            <Image src='emerald00007' />
            <Image src='emerald00008' />
            <Image src='emerald00009' />
            <Image src='emerald00010' />
            <Image src='emerald00011' />
            <Image src='emerald00012' />
            <Image src='emerald00013' />
            <Image src='emerald00014' />
            <Image src='emerald00015' />
            <Image src='emerald00016' />
            <Image src='emerald00017' />
            <Image src='emerald00018' />
            <Image src='emerald00019' />
        </MovieClip>
        <MovieClip name='ruby'>
            <Image src='ruby00000' />
            <Image src='ruby00001' />
            <Image src='ruby00002' />
            <Image src='ruby00003' />
            <Image src='ruby00005' />
            <Image src='ruby00006' />
            <Image src='ruby00007' />
            <Image src='ruby00008' />
            <Image src='ruby00010' />
            <Image src='ruby00011' />
            <Image src='ruby00012' />
            <Image src='ruby00013' />
            <Image src='ruby00014' />
            <Image src='ruby00015' />
            <Image src='ruby00016' />
            <Image src='ruby00017' />
            <Image src='ruby00018' />
            <Image src='ruby00019' />
        </MovieClip>
        <MovieClip name='sapphire'>
            <Image src='sapphire00000' />
            <Image src='sapphire00001' />
            <Image src='sapphire00002' />
            <Image src='sapphire00003' />
            <Image src='sapphire00004' />
            <Image src='sapphire00005' />
            <Image src='sapphire00006' />
            <Image src='sapphire00007' />
            <Image src='sapphire00008' />
            <Image src='sapphire00009' />
            <Image src='sapphire00010' />
            <Image src='sapphire00011' />
            <Image src='sapphire00012' />
            <Image src='sapphire00013' />
            <Image src='sapphire00014' />
            <Image src='sapphire00015' />
            <Image src='sapphire00016' />
            <Image src='sapphire00017' />
            <Image src='sapphire00018' />
            <Image src='sapphire00019' />
        </MovieClip>
        <MovieClip name='ruby_coin'>
            <Image src='ruby_coin00000' />
            <Image src='ruby_coin00001' />
            <Image src='ruby_coin00002' />
            <Image src='ruby_coin00003' />
            <Image src='ruby_coin00004' />
            <Image src='ruby_coin00005' />
            <Image src='ruby_coin00006' />
            <Image src='ruby_coin00007' />
            <Image src='ruby_coin00008' />
            <Image src='ruby_coin00009' />
            <Image src='ruby_coin00010' />
            <Image src='ruby_coin00011' />
            <Image src='ruby_coin00012' />
            <Image src='ruby_coin00013' />
            <Image src='ruby_coin00014' />
            <Image src='ruby_coin00015' />
            <Image src='ruby_coin00016' />
            <Image src='ruby_coin00017' />
            <Image src='ruby_coin00018' />
            <Image src='ruby_coin00019' />
        </MovieClip>
    </Sprite>
);
